import React from "react";

import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ReactComponent as IbanLogo } from "assets/images/iban_oplata-logo.svg";
import { ReactComponent as IbanLightLogo } from "assets/images/iban_oplata-light-logo.svg";

import { routes } from "routes/routes";
import { blogURL, blogRoutes } from "routes/blogRoutes";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

export enum PageHeadingVariant {
  LIGHT = "light",
  DARK = "dark",
}

export interface PageHeadingProps {
  variant?: PageHeadingVariant;
  showTitle?: boolean;
  isPreview?: boolean;
}

const PageHeading: React.FC<PageHeadingProps> = (props) => {
  const { variant, showTitle, isPreview } = props;

  const onLogoClick = () => {
    if (isPreview) {
      return;
    }

    analytics().sendConversionEvent(
      AnalyticsEvents.iban_qr_logo_click,
      null,
      true,
    );
    window.open(routes.root, "_blank");
  };

  const onBlogClick = () => {
    if (isPreview) {
      return;
    }

    analytics().sendConversionEvent(
      AnalyticsEvents.iban_qr_blog_click,
      null,
      true,
    );
    window.open(`${blogURL}/${blogRoutes.ibanInvoiceInstruction}`, "_blank");
  };

  const renderLogo = () => {
    switch (variant) {
      case PageHeadingVariant.LIGHT:
        return (
          <IbanLightLogo style={{ cursor: "pointer" }} onClick={onLogoClick} />
        );

      default:
        return <IbanLogo style={{ cursor: "pointer" }} onClick={onLogoClick} />;
    }
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      {renderLogo()}
      {showTitle && (
        <Typography
          variant="h5"
          fontWeight={600}
          sx={{ mr: "auto", ml: 1 }}
          color={
            variant === PageHeadingVariant.LIGHT ? "grey000" : "textPrimary"
          }
        >
          Оплата рахунку по IBAN
        </Typography>
      )}
      <Link
        variant="subtitle2"
        sx={{ cursor: "pointer" }}
        color={variant === PageHeadingVariant.LIGHT ? "grey000" : "textPrimary"}
        onClick={onBlogClick}
      >
        Більше про IBAN oplata
      </Link>
    </Stack>
  );
};

export default PageHeading;
